<template>
    <thead class="thead">
        <tr class="tr">
            <th class="th">Coin</th>
            <th class="th cursor-pointer" v-for="columnWithSettings in visibleColumnsWithSettings" @click="sortOn(columnWithSettings.column)">{{ columnWithSettings.settings.title }}</th>
        </tr>
    </thead>
</template>

<script>
import portfolioColumns from '@/services/portfolioColumns'

export default {
    computed:{
        visibleColumnsWithSettings(){
            return portfolioColumns.visibleColumnsWithSettings
        },
    },
    methods:{
        sortOn(columnName){
            this.$emit('sortOn', columnName)
        },
    }
}
</script>